var render = function render(){var _vm=this,_c=_vm._self._c;return (this.commercialRandom[0])?_c('div',{staticClass:"banner"},[(this.commercialRandom[0].coupons)?_c('router-link',{attrs:{"to":{
      name: 'Compras',
      params: { id: this.commercialRandom[0].coupons.id },
    },"target":"_blank"}},[_c('img',{staticClass:"banner__img",attrs:{"src":this.commercialRandom[0].image.url}})]):(this.commercialRandom[0].url)?_c('a',{attrs:{"href":this.commercialRandom[0].url,"target":"_blank"}},[_c('img',{staticClass:"banner__img",attrs:{"src":this.commercialRandom[0].image.url}})]):_vm._e(),_c('br'),_c('br')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }